import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/$versionId/")({
  staticData: {
    title: "versions.title",
  },
  loader: () => {
    throw redirect({
      to: "/resources/$id/versions/$versionId/general",
      from: "/resources/$id/versions/$versionId/",
    });
  },
});
